"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OVERRIDE_EVENTS = void 0;
var report_1 = require("@shared/types/report");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
exports.OVERRIDE_EVENTS = {
    ADD_BREAKOUT_HEADERS: 'ADD_BREAKOUT_HEADERS',
    CONFIG_FLAGS: 'CONFIG_FLAGS',
    CREATE_REPORT_CONTROLLER: 'CREATE_REPORT_CONTROLLER',
    CREATE_REPORT_MESSAGE: 'CREATE_REPORT_MESSAGE',
    CREATE_REPORT_OPTIONS: 'CREATE_REPORT_OPTIONS',
    CREATE_REPORT_TEMPLATE: 'CREATE_REPORT_TEMPLATE',
    CUSTOM_HEADER_TEMPLATE: 'CUSTOM_HEADER_TEMPLATE',
    DATA_HTTP_RESPONSE: 'DATA_HTTP_RESPONSE',
    DISABLE_RICH_TEXT: 'DISABLE_RICH_TEXT',
    DOWNLOAD_OPTIONS: 'DOWNLOAD_OPTIONS',
    EXPORT_BUTTON: 'EXPORT_BUTTON',
    FAIL_EXPORT_ON_TIMEOUT: 'FAIL_EXPORT_ON_TIMEOUT',
    FILE_MENU: 'FILE_MENU',
    FILTER_PERMISSIONS: 'FILTER_PERMISSIONS',
    FILTERS_CLIENT_FIELDSET_DEF: 'FILTERS_CLIENT_FIELDSET_DEF',
    FOLDER_API_OPTIONS: 'FOLDER_API_OPTIONS',
    FOLDER_MENU: 'FOLDER_MENU',
    HEADER_OPTIONS: 'HEADER_OPTIONS',
    IMAGE_POSITIONS: 'IMAGE_POSITIONS',
    INSERT_MENU: 'INSERT_MENU',
    LANGUAGE_CODES: 'LANGUAGE_CODES',
    NEW_CONTAINER_DEFINITION: 'NEW_CONTAINER_DEFINITION',
    NO_REPORTS_MESSAGE: 'NO_REPORTS_MESSAGE',
    PAGE_FILTER_MENU: 'PAGE_FILTER_MENU',
    PIPED_TEXT_MENU: 'PIPED_TEXT_MENU',
    REPORT_ERROR: 'REPORT_ERROR',
    DATA_REQUEST_OPTIONS: 'DATA_REQUEST_OPTIONS',
    ROUTES: 'ROUTES',
    SINGLE_FIELDSET: 'SINGLE_FIELDSET',
    SOURCE_DATA_MENU: 'SOURCE_DATA_MENU',
    SWITCH_OPTIONS: 'SWITCH_OPTIONS',
    THROW_FAILED_EXPORTS: 'THROW_FAILED_EXPORTS',
    TRANSFORM_GRID_RESPONSE: 'TRANSFORM_GRID_RESPONSE',
    VALIDATE_IMPORTED_CONTAINER_DEF: 'VALIDATE_IMPORTED_CONTAINER_DEF',
    WIDGET_CONFIG_INIT: 'WIDGET_CONFIG_INIT'
}; // force the compiler to preserve literal types
var overrideServiceNames = (_a = {},
    _a[report_1.REPORT_TYPE.EE] = 'prEEOverride',
    _a[report_1.REPORT_TYPE.TS] = 'pr360Override',
    _a);
(function (module) {
    module.constant('pr.OVERRIDE_EVENTS', exports.OVERRIDE_EVENTS);
    /**
     * prOverride should not be injected directly outside of this file
     * external files should inject prOverrideRegister or prOverrideTrigger
     */
    module.factory('prOverride', [
        '$q',
        'pr.loggerService',
        // @ts-ignore
        // @ts-ignore
        function ($q, loggerService) {
            var loggerManager = loggerService.getLoggerManager('prOverride');
            var functionMap = lodash_1.default.mapValues(exports.OVERRIDE_EVENTS, function () { return []; });
            return {
                /**
                 * https://qualtrics.atlassian.net/browse/REP-6093
                 * @todo look into avoiding calls to cloneDeep when invoking the overrides
                 * This can result in unnecessary copies of a lot of data, especially if
                 * triggerOverrides is called in each angular digest cycle.
                 *
                 * Applies the registered override functions to the data in order of registration.
                 * @param {*} options
                 *   @property {String} event
                 *   @property {object} data - to be passed to registered functions
                 *   @property {boolean} sync - flag if the override functions are synchronous
                 * @returns {*} - the data after iteratively applying registered functions.
                 *                Returns value if options.sync is true, promise otherwise.
                 */
                triggerOverrides: function (options) {
                    try {
                        if (!isValidEvent(lodash_1.default.get(options, 'event'))) {
                            throw new Error("Invalid event: " + options.event);
                        }
                        var functions = functionMap[options.event];
                        var invokeFuncs = options.sync ? invokeFunctionsSync : invokeFunctions;
                        // @ts-ignore
                        return invokeFuncs(functions, options.data, options.throwErrors);
                    }
                    catch (error) {
                        var errorMessage = "Failed to trigger overrides: " + error.message;
                        console.error(errorMessage, error);
                        if (options.throwErrors) {
                            throw error;
                        }
                        if (options.sync) {
                            return options.data;
                        }
                        return $q.resolve(options.data);
                    }
                },
                /**
                 * Associates the specified function with the specified event
                 * @param {String} event
                 * @param {Function} func
                 */
                registerOverride: function (event, func) {
                    try {
                        if (!isValidEvent(event) || !lodash_1.default.isFunction(func)) {
                            throw new Error('Invalid function or event');
                        }
                        functionMap[event].push(func);
                    }
                    catch (error) {
                        var errorMessage = "Failed to register override: " + error.message;
                        console.error(errorMessage, error);
                        loggerManager.error(errorMessage);
                    }
                }
            };
            /**
             * Checks if the given event is valid
             * @param {String} event
             * @returns {Boolean}
             */
            function isValidEvent(event) {
                // @ts-ignore
                return lodash_1.default.isString(event) && lodash_1.default.isArray(functionMap[event]);
            }
            /**
             * Successively invokes the given functions on given data.
             * Assumes that all functions are synchronous
             * @param {Array.<Function>} functions - an array of functions to invoke
             * @param {*} data - data to invoke functions on
             * @returns {*} - the data after successive invocations
             */
            function invokeFunctionsSync(functions, data, throwErrors) {
                data = lodash_1.default.cloneDeep(data);
                lodash_1.default.forEach(functions, function (func) {
                    try {
                        data = func(data);
                    }
                    catch (error) {
                        if (throwErrors) {
                            throw error;
                        }
                        // if error occurs try invoking next function
                        console.error(error);
                    }
                });
                return data;
            }
            /**
             * Successively invokes the given functions on given data.
             * Catches sync and async errors.
             * @param {Array.<Function>} functions - an array of functions to invoke
             * @param {*} data - data to invoke functions on
             * @param {Number} index - index in 'functions' array to pull next function
             * @returns {Promise<*>} - whatever is returned from successive invocations
             */
            function invokeFunctions(functions, data, throwErrors, index) {
                if (index === void 0) { index = 0; }
                if (!functions || !lodash_1.default.isNumber(index) || !lodash_1.default.isFunction(functions[index])) {
                    // base step
                    return $q.resolve(data);
                }
                return $q.resolve().then(function () {
                    // invoke current function on data
                    var func = functions[index];
                    return lodash_1.default.isFunction(func) ? func(lodash_1.default.cloneDeep(data)) : data;
                    // @ts-ignore
                }).catch(function (error) {
                    if (throwErrors) {
                        throw error;
                    }
                    // if error occurs try invoking next function
                    console.error(error);
                    return data;
                    // @ts-ignore
                }).then(function (newData) {
                    // invoke next function
                    return invokeFunctions(functions, newData, throwErrors, index + 1);
                });
            }
        }
    ]);
    /**
     * We need to guarantee that all registerOverride calls occur before any triggerOverrides calls.
     * To do this, split triggerOverrides and registerOverrides methods into separate modules.
     * The dependency order will be prOverrideTrigger -> Override File -> prOverrideRegister.
     */
    // Should be injected by override files
    module.factory('prOverrideRegister', [
        'prOverride',
        function (overrideService) {
            return overrideService.registerOverride.bind(overrideService);
        }
    ]);
    // Should be injected by core pr code
    module.factory('prOverrideTrigger', [
        '$injector',
        'prOverride',
        'pr.reportTypeService',
        // @ts-ignore
        // @ts-ignore
        function ($injector, overrideService, reportTypeService) {
            var reportType = reportTypeService.getReportType();
            // @ts-ignore
            var overrideServiceName = overrideServiceNames[reportType];
            if (overrideServiceName) {
                // inject team specific override file to enforce ordering
                $injector.get(overrideServiceName);
            }
            return function (options) {
                // By not returning the function reference directly,
                // it is bound to overrideService when the function is called
                // which allows changing the binding object in unit tests
                return overrideService.triggerOverrides.call(overrideService, options);
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
